/**
 * Catálogo de los códigos del certificado de Renta Pagada (F-22 presentado
 * ante el SII) para AT 2025, Régimen 14D8.
 *
 * CODIGOS_PAGADO es GENERADO: no editar a mano. Sale de cruzar las columnas de
 * la tabla `renta_2025_14d8_pagado` con las descripciones del prompt en
 * src/ai-extractors/f22/14d8.js. Para regenerarlo:
 *
 *     npm run codigos-pagado
 *
 * CODIGOS_DESTACADOS sí se edita a mano: es la decisión de qué códigos merecen
 * ir arriba de todo en la página. El generador lo respeta tal como esté.
 *
 * Propio de ESTE año+régimen (mismo criterio que formulas.js/persistence.js):
 * si el SII cambia o agrega códigos en un año futuro, este archivo no se toca.
 */

export const CODIGOS_PAGADO = [
  { column: 'cod_1600', codigo: '1600', nombre: 'Ingresos del giro percibidos' },
  { column: 'cod_1819', codigo: '1819', nombre: 'Ingresos del giro devengados en ejercicios anteriores y percibidos en el ejercicio actual' },
  { column: 'cod_1601', codigo: '1601', nombre: 'Rentas de fuente extranjera percibidas' },
  { column: 'cod_1602', codigo: '1602', nombre: 'Intereses y reajustes percibidos por préstamos y otros' },
  { column: 'cod_1603', codigo: '1603', nombre: 'Mayor valor percibido por rescate o enajenación de inversiones o bienes no depreciables' },
  { column: 'cod_1604', codigo: '1604', nombre: 'Dividendos o retiros percibidos en el ejercicio, por participaciones en otras empresas' },
  { column: 'cod_1605', codigo: '1605', nombre: 'Incremento por IDPC' },
  { column: 'cod_1606', codigo: '1606', nombre: 'Ingresos percibidos o devengados por operaciones con empresas relacionadas del art. 14 letra A) LIR' },
  { column: 'cod_1607', codigo: '1607', nombre: 'Otros ingresos percibidos o devengados' },
  { column: 'cod_1608', codigo: '1608', nombre: 'Ingreso diferido imputado en el ejercicio, debidamente incrementado y reajustado, cuando corresponda' },
  { column: 'cod_1609', codigo: '1609', nombre: 'Crédito por activos fijos adquiridos en el ejercicio (art. 33 bis LIR)' },
  { column: 'cod_1610', codigo: '1610', nombre: 'Total de ingresos anuales' },
  { column: 'cod_1611', codigo: '1611', nombre: 'Gasto por saldo inicial de existencias o insumos del negocio en cambio de régimen, pagados' },
  { column: 'cod_1612', codigo: '1612', nombre: 'Gasto por saldo inicial de activos fijos depreciables en cambio de régimen, pagados' },
  { column: 'cod_1613', codigo: '1613', nombre: 'Gasto por pérdida tributaria en cambio de régimen' },
  { column: 'cod_1614', codigo: '1614', nombre: 'Existencias, insumos y servicios del negocio, pagados' },
  { column: 'cod_1820', codigo: '1820', nombre: 'Existencias, insumos y servicios del negocio adeudados en ejercicios anteriores y pagados en el ejercicio actual' },
  { column: 'cod_1615', codigo: '1615', nombre: 'Gastos de rentas de fuente extranjera, pagados' },
  { column: 'cod_1616', codigo: '1616', nombre: 'Remuneraciones pagadas' },
  { column: 'cod_1617', codigo: '1617', nombre: 'Honorarios pagados' },
  { column: 'cod_1618', codigo: '1618', nombre: 'Adquisición de bienes del activo fijo, pagados' },
  { column: 'cod_1620', codigo: '1620', nombre: 'Arriendos pagados' },
  { column: 'cod_1621', codigo: '1621', nombre: 'Gastos por exigencias medio ambientales, pagados' },
  { column: 'cod_1622', codigo: '1622', nombre: 'Intereses y reajustes pagados por préstamos y otros' },
  { column: 'cod_1624', codigo: '1624', nombre: 'Pérdida en rescate o enajenación de inversiones o bienes no depreciables' },
  { column: 'cod_1625', codigo: '1625', nombre: 'Otros gastos deducibles de los ingresos' },
  { column: 'cod_1626', codigo: '1626', nombre: 'Gastos o egresos pagados o adeudados por operaciones con empresas relacionadas del art. 14 letra A) LIR' },
  { column: 'cod_1627', codigo: '1627', nombre: 'Pérdidas tributarias de ejercicios anteriores' },
  { column: 'cod_1628', codigo: '1628', nombre: 'Créditos incobrables castigados en el ejercicio (reconocidos sobre ingresos devengados)' },
  { column: 'cod_1909', codigo: '1909', nombre: 'Gastos aceptados por donaciones' },
  { column: 'cod_1629', codigo: '1629', nombre: 'Total de egresos anuales' },
  { column: 'cod_1630', codigo: '1630', nombre: 'Base imponible a asignar a propietarios contribuyentes de impuestos finales, o pérdida tributaria del ejercicio' },
  { column: 'cod_1580', codigo: '1580', nombre: 'CPT o CPTS positivo inicial' },
  { column: 'cod_1582', codigo: '1582', nombre: 'CPT o CPTS negativo inicial' },
  { column: 'cod_1573', codigo: '1573', nombre: 'Capital aportado empresas que inician actividades en el año comercial' },
  { column: 'cod_1574', codigo: '1574', nombre: 'Aumentos (efectivos) de capital del ejercicio' },
  { column: 'cod_1575', codigo: '1575', nombre: 'Disminuciones (efectivas) de capital del ejercicio' },
  { column: 'cod_1712', codigo: '1712', nombre: 'Base imponible del ejercicio, asignable a los propietarios' },
  { column: 'cod_1713', codigo: '1713', nombre: 'Pérdida tributaria del ejercicio al 31 de diciembre' },
  { column: 'cod_1714', codigo: '1714', nombre: 'Pérdidas tributarias de ejercicios anteriores' },
  { column: 'cod_1576', codigo: '1576', nombre: 'Remesas, retiros o dividendos repartidos en el ejercicio' },
  { column: 'cod_1715', codigo: '1715', nombre: 'Ingreso diferido imputado en el ejercicio' },
  { column: 'cod_1577', codigo: '1577', nombre: 'Partidas de gastos no aceptados' },
  { column: 'cod_1716', codigo: '1716', nombre: 'Crédito por activos fijos adquiridos en el ejercicio (art. 33 bis LIR)' },
  { column: 'cod_1578', codigo: '1578', nombre: 'Crédito por IDPC, por participaciones en otras empresas' },
  { column: 'cod_1584', codigo: '1584', nombre: 'Otras partidas a agregar' },
  { column: 'cod_1585', codigo: '1585', nombre: 'Otras partidas a deducir' },
  { column: 'cod_1581', codigo: '1581', nombre: 'CPTS positivo final' },
  { column: 'cod_1583', codigo: '1583', nombre: 'CPTS negativo final' },
  { column: 'cod_305', codigo: '305', nombre: 'Resultado Liquidación Anual Impuesto a la Renta' },
  { column: 'cod_39', codigo: '39', nombre: 'Reajuste art. 72 LIR, código 305' },
  { column: 'cod_85', codigo: '85', nombre: 'Saldo a favor' },
  { column: 'cod_87', codigo: '87', nombre: 'Monto devolución solicitada' },
  { column: 'cod_90', codigo: '90', nombre: 'Impuesto adeudado' },
  { column: 'cod_91', codigo: '91', nombre: 'Total a pagar (códigos 90 y 39)' },
  { column: 'cod_645', codigo: '645', nombre: 'CPT positivo final' },
  { column: 'cod_646', codigo: '646', nombre: 'CPT negativo final' },
  { column: 'cod_315', codigo: '315', nombre: 'Fecha de Presentación de la declaración' },
];

/**
 * Los códigos que resumen el resultado de la declaración. La página del
 * certificado los muestra destacados arriba, antes de la tabla completa.
 */
export const CODIGOS_DESTACADOS = [
  { column: 'cod_1630', etiqueta: 'Base imponible a asignar a propietarios' },
  { column: 'cod_1581', etiqueta: 'CPTS positivo final' },
  { column: 'cod_305', etiqueta: 'Resultado liquidación anual' },
  { column: 'cod_91', etiqueta: 'Total a pagar' },
];
